
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'PaymentOfferSendButton',
})
export default class PaymentOfferSendButton extends Vue {}
